import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Button, Icon, Input, Dropdown } from 'semantic-ui-react'

import { getV2TrainingModules, createV2TrainingModule, updateV2TrainingModule, archiveV2TrainingModule, unarchiveV2TrainingModule } from '../actions/v2_training_modules'
import * as v2TrainingModulesConstants from '../constants/v2_training_modules'
import { getCategorizedTags, createTag } from '../actions/tags'
import { updateTag } from '../actions/v2_tags'
import ModalAddV2TrainingModule from './components/modals/add_v2_training_module'
import UpdateTagsModal from './components/modals/update_tags'
import ModalEditV2TrainingModule from './components/modals/edit_v2_training_module'
import V2TrainingModulesTable from './components/tables/v2_training_modules_table'
import * as tagsConstants from '../constants/tags'
import * as v2TrainingModulesActions from '../actions/v2_training_modules'
import ConfirmationModal from './components/modals/confirmation_modal';
import TagFormModal from './components/modals/training_matrix_modal'
import AppComponent from './components/app_component'

class V2TrainingModules extends AppComponent {
  constructor(props){
    super(props);

    this.state = {
      showFormAddModule: false,
      showFormEditModule: false,
      showUpdateTagsModule: false,
      restrictUpdate: false,
      selectedRow: {},
      v2TrainingModules: [],
      filterOptions: {
        id: '',
        tag_name: '',
        search_term: '',
        include_archived_modules: false,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        context: 'tags'
      },
      allTags: [
        {
          key: 'All Training Modules',
          text: 'All Training Modules',
          value: ''
        }
      ],
      team: '',
      editShown: false,
      mode: '',
      renderV2TrainingModulesTable: true,
      isRegion: false,
      regions: [],
      tags: [],
      showTagForm: false,
      tagFormMode: 'create'
    }

    this.trainingModuleName = null;
    this.trainingModuleId = null;
    this.loading = this.props.loading;
    this.moduleData = {
      name: null,
      default_frequency: null,
      category: null
    }

    this.newTag = ''
    this.origTag = ''

    this.searchTrainingModule = this.searchTrainingModule.bind(this)
    this.onTagChange = this.onTagChange.bind(this)
    this.onEditTeam = this.onEditTeam.bind(this)
    this.onFocusTeam = this.onFocusTeam.bind(this)
    this.onBlurTeam = this.onBlurTeam.bind(this)
    this.editTeam = this.editTeam.bind(this)
    this.saveTag = this.saveTag.bind(this)
    this.updateTags = this.updateTags.bind(this)
    this.clearFilters = this.clearFilters.bind(this)
  }

  // FUNCTIONS FOR DATA MANIPULATION
  componentDidMount() {
    this.props.getCategorizedTags()
    this.props.getV2TrainingModules()
  }

  componentWillReceiveProps(nextProps){
    this.handleTagsNextProps(nextProps)
    this.handleV2TrainingModulesNextProps(nextProps)
    this.handleV2TagsNextProps(nextProps)
  }

  handleTagsNextProps = (nextProps) => {
    if (this.props.tagsRequestType === nextProps.tagsRequestType) return;
    const { tagsRequestType, tagsRequestSuccess } = nextProps 

    if (tagsRequestSuccess && tagsRequestType === tagsConstants.GET_CATEGORIZED_TAGS_SUCCESS) {
      this.setState({
        tags: nextProps.tags,
        regions: nextProps.regions,
        allTags: nextProps.allTags
      })
      this.hideLoadingMessage()
    }
    else if ([tagsConstants.CREATE_TAG_SUCCESS].includes(tagsRequestType)) {
      var { filterOptions } = this.state
      filterOptions.id = nextProps.tag.id
      filterOptions.tag_name = nextProps.tag.name
      this.setState({filterOptions})

      this.hideLoadingMessage()
      this.props.getCategorizedTags()
      this.props.getV2TrainingModules(filterOptions)
    }
    else {
      this.showLoadingMessage()
    }
  }

  handleV2TrainingModulesNextProps = (nextProps) => {
    if (nextProps.requestSuccess){
      switch(nextProps.requestType){
        case v2TrainingModulesConstants.GET_V2_TRAINING_MODULES_SUCCESS:
          this.setState({
            v2TrainingModules: nextProps.v2TrainingModules
          })
          break
        case v2TrainingModulesConstants.CREATE_V2_TRAINING_MODULE_SUCCESS:
          this.setState({ showFormAddModule: false, restrictUpdate: false  });
        case v2TrainingModulesConstants.UPDATE_V2_TRAINING_MODULE_SUCCESS:
          this.setState({ showFormEditModule: false, restrictUpdate: false  });
        case v2TrainingModulesConstants.ARCHIVE_V2_TRAINING_MODULE_SUCCESS:
        case v2TrainingModulesConstants.UNARCHIVE_V2_TRAINING_MODULE_SUCCESS:
          this.props.getV2TrainingModules(this.getFilterOptions())
          break
        default: break
      }
      this.hideLoadingMessage()
    }
    else {
      switch(nextProps.requestType){
        case v2TrainingModulesConstants.CREATE_V2_TRAINING_MODULE_FAILURE:
        case v2TrainingModulesConstants.UPDATE_V2_TRAINING_MODULE_FAILURE:
          this.hideLoadingMessage();
          break
        default:
          this.showLoadingMessage();
          break
      }
    }
  }

  handleV2TagsNextProps = (nextProps) => {
    if (this.props.v2tags.requestType === nextProps.v2tags.requestType) return
    var { id, name } = nextProps.v2tags.tagMatrix
    var { filterOptions } = this.state

    if (['UPDATE_TAG_SUCCESS'].includes(nextProps.v2tags.requestType)) {
      filterOptions.id = id
      filterOptions.tag_name = name

      this.setState({ filterOptions })
      this.hideLoadingMessage()
      this.props.getCategorizedTags()
      this.props.getV2TrainingModules(filterOptions)
     }
     else {
      this.showLoadingMessage()
     }    
  }

  getFilterOptions = () => {
    var { filterOptions } = this.state
    var newFilterOptions = { search_term: filterOptions.search_term, include_archived_modules: filterOptions.include_archived_modules }
    if(filterOptions.tag_name.length > 0) {
      newFilterOptions.tag_name = filterOptions.tag_name
      newFilterOptions.context = filterOptions.context
    }

    return newFilterOptions
  }

  // FUNCTIONS FOR API CALLS
  searchTrainingModule = (evt) => {
    let filterOptions = this.state.filterOptions
    filterOptions.search_term = evt.target.value
    this.setState({
      filterOptions: filterOptions
    })
    this.props.getV2TrainingModules(this.getFilterOptions())
  }

  onTagChange = (evt, obj) => {
    var { filterOptions } = this.state
    if (obj.value === filterOptions.tag_name){
      return
    }

    var isRegion = this.isInObjectArray(this.state.regions, obj.value)
    filterOptions.tag_name = obj.value
    filterOptions.context = isRegion ? 'regions' : 'tags'
    filterOptions.id = this.getTagId(obj.value)
  
    this.setState({ filterOptions, isRegion })
    this.props.getV2TrainingModules(filterOptions)
  }

  onFocusTeam(evt){
    this.origTag = evt.target.value
  }

  onEditTeam(evt){
    this.newTag = evt.target.value
    this.setState({
      team: evt.target.value,
      renderV2TrainingModulesTable: false
    })
  }

  onBlurTeam(evt){
    this.newTag = evt.target.value
    this.setState({
      renderV2TrainingModulesTable: true
    })
  }

  editTeam(evt){
    let team = this.state.filterOptions.tag_name
    this.origTag = team
    let mode = evt.target.name
    if (mode === 'new'){
      team = ''
    }

    let filterOptions = this.state.filterOptions
    filterOptions.tag_list = []
    filterOptions.context = ''

    this.setState({
      editShown: true,
      mode: mode,
      team: team,
      filterOptions: filterOptions
    })

    this.props.getV2TrainingModules(filterOptions)
  }

  saveTag(evt){
    this.newTag = this.newTag.length > 0 ? this.newTag : this.state.filterOptions.tag_name
    let allTags = this.state.allTags
    let found = allTags.some((team) => {
      return team.value === this.newTag
    });
    if(!found){
      allTags.push({
        key:  this.newTag,
        text: this.newTag,
        value: this.newTag,
        context: 'tags'
      })
    }

    let filterOptions = this.state.filterOptions
    filterOptions.tag_list = this.newTag.length === 0 ? [] : [].concat(this.newTag)
    let isRegion = this.isInObjectArray(this.state.regions, this.newTag)
    filterOptions.context = isRegion ? 'regions' : 'tags'

    this.setState({
      editShown: false,
      mode: '',
      allTags: allTags,
      filterOptions: filterOptions
    })

    if (this.origTag !== this.newTag) {
      let options = {
        old_tag_name: this.origTag,
        new_tag_name: this.newTag,
      }
      this.renameTag(options)
    } else {
      this.props.getV2TrainingModules(filterOptions)
      this.origTag = ''
      this.newTag = ''
    }

  }

  updateTags(params) {
    this.shouldFetchV2TrainingModules = true
    this.props.updateV2TrainingModule(params)
  }

  renameTag = (options) => {
    this.props.renameTag(options).then((response)=>{
      let allTags = this.state.allTags.filter(function(team, index, arr){
        return team.text !== this.origTag;
      }.bind(this));
      this.setState({
        team: this.newTag,
        allTags: allTags
      })
      this.props.getV2TrainingModules(this.state.filterOptions)
      this.origTag = ''
      this.newTag = ''
    })
  }

  clearFilters(evt){
    let filterOptions = this.state.filterOptions
    filterOptions.search_term = ''
    filterOptions.tag_name = ''
    filterOptions.context = 'tags'
    this.setState({filterOptions})
    this.props.getV2TrainingModules(this.getFilterOptions())
  }

  toggleArchived = (evt) => {
    let filterOptions = this.state.filterOptions
    filterOptions.include_archived_modules = !filterOptions.include_archived_modules
    this.setState({
      filterOptions: filterOptions
    }, ()=>{
      this.props.getV2TrainingModules(this.getFilterOptions())
    })
  }

  setSelectedRow = (selectedRow) => {
    this.setState({selectedRow})
  }

  showArchiveModal(evt){
    this.setState({
      showArchiveModal: true,
      restrictUpdate: true
    })
  }

  archiveV2TrainingModule = (trainingModuleListId) => {
    this.setState({
      showArchiveModal: false
    })
    this.props.archiveV2TrainingModule(trainingModuleListId)
  }

  showUnarchiveModal(evt){
    this.setState({
      showUnarchiveModal: true,
      restrictUpdate: true
    })
  }

  unarchiveV2TrainingModule = (trainingModuleListId) => {
    this.setState({
      showUnarchiveModal: false,
      restrictUpdate: true
    })
    this.props.unarchiveV2TrainingModule(trainingModuleListId)
  }

  toggleTagForm = (show) => {
    this.setState({ showTagForm: show })
    if(!show) this.props.getV2TrainingModules(this.getFilterOptions())
  }

  createNewTag = (evt) => {
    this.setState({
      showTagForm: true,
      tagFormMode: 'create'
    })
  }

  onCreateTag = (tag) => {
    this.props.createTag(tag);

    var { filterOptions } = this.state
    filterOptions.tag_name = tag.tag_name
    this.setState({ 
      filterOptions,
      showTagForm: false,
    })
  }

  updateTag = (evt) => {
    var { filterOptions, v2TrainingModules } = this.state
    filterOptions.modules_ids = v2TrainingModules.map((training_module)=>{return training_module.id})
    this.setState({
      showTagForm: true,
      tagFormMode: 'update',
      filterOptions
    })
  }

  onUpdateTag = (tag) => {
    this.props.updateTag(tag);

    var { filterOptions } = this.state
    filterOptions.tag_name = tag.tag_name
    this.setState({ 
      filterOptions,
      showTagForm: false,
    })
  }

  render() {
    const { showFormAddModule, showUpdateTagsModule, showFormEditModule, showArchiveModal, showUnarchiveModal, showTagForm, tagFormMode, filterOptions,
            selectedRow: trainingModule } = this.state;
    const { userIsAdmin, createError, updateError } = this.props;
  
    return (
      <div className='training-matrix'>
        {
          showTagForm &&
          <TagFormModal
            onCreate={this.onCreateTag}
            onUpdate={this.onUpdateTag}
            onClose={ (evt) => this.toggleTagForm(false) }
            tag={filterOptions}
            mode={tagFormMode}
            context='tags'
            parentName='V2TrainingModules'
          />
        }
        {
          showFormAddModule &&
          <ModalAddV2TrainingModule
            show={ showFormAddModule }
            onAddEvent={ this.props.createV2TrainingModule }
            onClose={ () => this.setState({ showFormAddModule: false, restrictUpdate: false  }) }
            existingModules={this.state.v2TrainingModules}
            errorMessage={createError}
          />
        }
        {
          showUpdateTagsModule && this.state.tags.length > 0 &&
          <UpdateTagsModal
            show={ showUpdateTagsModule }
            onClose={ () => this.setState({ showUpdateTagsModule: false }) }
            tags={this.state.tags}
            regions={this.state.regions}
            tagged_item={this.state.selectedRow}
            updateTags={this.updateTags}
          />
        }
        {
          showArchiveModal &&
          <ConfirmationModal
            show={ showArchiveModal }
            title = 'Archive Training Module'
            message = {`Are you sure you want to archive  ${this.state.selectedRow.id} - ${this.state.selectedRow.name}?`}
            positiveLabel = 'Archive'
            negativeLabel = 'Cancel'
            positiveCallback = { () => this.archiveV2TrainingModule(this.state.selectedRow.id) }
            negativeCallback = { () => this.setState({ showArchiveModal: false, restrictUpdate: false  }) }
          />
        }
        {
          showUnarchiveModal &&
          <ConfirmationModal
            show={ showUnarchiveModal }
            title = 'Unarchive Training Module'
            message = {`Are you sure you want to unarchive ${this.state.selectedRow.id} - ${this.state.selectedRow.name}?`}
            positiveLabel = 'Unarchive'
            negativeLabel = 'Cancel'
            positiveCallback = { () => this.unarchiveV2TrainingModule(this.state.selectedRow.id) }
            negativeCallback = { () => this.setState({ showUnarchiveModal: false, restrictUpdate: false  }) }
          />
        }

        {
          showFormEditModule &&
          <ModalEditV2TrainingModule
            show={ showFormEditModule }
            moduleData={ this.state.selectedRow }
            onEditEvent={ this.props.updateV2TrainingModule }
            onClose={ () => this.setState({ showFormEditModule: false, restrictUpdate: false  }) }
            existingModules={this.state.v2TrainingModules}
            errorMessage={updateError}
          />
        }
        <div className='matrix-toolbar'>
          {
            <Input
              placeholder='Search Training Module'
              onChange={this.searchTrainingModule}
              value={this.state.filterOptions.search_term}
            />
          }

          {
            <Dropdown
              placeholder='Select a tag'
              selection
              search
              options={this.state.allTags}
              onChange={this.onTagChange}
              value={this.state.filterOptions.tag_name}
            />
          }
          {
            (this.state.filterOptions.search_term.length > 0 || this.state.filterOptions.tag_name.length > 0) &&
            <span className='anglo-links' onClick={this.clearFilters}>Clear Filters</span>
          }
          {
            userIsAdmin &&
            <Fragment>
              {
                this.state.filterOptions.tag_name.length !== 0 && !this.state.isRegion &&
                <Button
                  primary
                  onClick={this.updateTag}
                  name='edit'
                >
                  <Icon name='pencil'/>Edit Training Module Tag
                </Button>
              }
              <Button
                primary
                onClick={() => this.setState({ showFormAddModule: true }) }
              >
                <Icon name='user'/>Add Training Module
              </Button>
            </Fragment>
          }
          <span style={{marginLeft: 10}}>
            {
              !this.state.filterOptions.include_archived_modules &&
              <span className='anglo-links' style={{marginLeft: '0px'}} onClick={this.toggleArchived}>Show Archived Training Modules</span>
            }
            {
              this.state.filterOptions.include_archived_modules &&
              <span className='anglo-links' style={{marginLeft: '0px'}} onClick={this.toggleArchived}>Hide Archived Training Modules</span>
            }
          </span>

        </div>
        <div id='table_column_contextmenu'>
          <div as='a' onClick={ () => this.setState({ showFormAddModule: true, restrictUpdate: true }) } className="table_contextmenu">
              <Icon name='book'/>Add Module
          </div>
          <div id="edit_module_menu" as='a' onClick={ () => this.setState({ showFormEditModule: true, restrictUpdate: true }) } className="table_contextmenu">
              <Icon name='edit'/>Edit Module
          </div>
        </div>
        <div id='table_row_contextmenu'>
          <div as='a' onClick={ () => this.setState({ showFormEditModule: true, restrictUpdate: true }) } className="table_contextmenu">
            <Icon name='user' />Edit Training Module
          </div>
          <div as='a' onClick={ (evt) => this.showArchiveModal(evt) } className="table_contextmenu">
            <Icon name='file archive' />Archive Training Module
          </div>
        </div>
        <div id='archived_table_row_contextmenu' style={{pointerEvents: 'auto'}}>
          <div as='a' onClick={ (evt) => this.showUnarchiveModal(evt) } className="table_contextmenu">
            <Icon name='file archive' />Unarchive Training Module
          </div>
        </div>
        {
          <div className='tables-row'>
            <div className='tables-row-full'>
              <div className='team-heading'>
                {
                  (this.state.filterOptions.tag_name.length > 0 ? (<span>Tag Name: <span className='team-name ui label'>{this.state.filterOptions.tag_name}</span></span>) : 'All Training Modules')
                }
              </div>
              <V2TrainingModulesTable
                v2TrainingModules={this.state.v2TrainingModules}
                mode='view'
                type='all'
                tagName={this.state.filterOptions.tag_name}
                regions={this.state.regions}
                allTags={this.state.allTags}
                updateTags={this.updateTags}
                onTeamClick={this.onTagChange}
                tags={this.state.tags}
                render={this.state.renderV2TrainingModulesTable}
                setSelectedRow={this.setSelectedRow}
                fetchingTrainingModules={!this.props.requestSuccess}
                userIsAdmin={userIsAdmin}
              />
            </div>
          </div>
        }
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    complianceRatings: state.trainingMatrix.complianceRatings,
    v2TrainingModules: state.v2TrainingModules.v2TrainingModules,
    requestSuccess: state.v2TrainingModules.requestSuccess,
    requestType: state.v2TrainingModules.requestType,
    createError: state.v2TrainingModules.createError,
    updateError: state.v2TrainingModules.updateError,
    tags: state.tags.tags,
    regions: state.tags.regions,
    allTags: state.tags.allTags,
    tagsRequestSuccess: state.tags.requestSuccess,
    tagsRequestType: state.tags.requestType,
    tag: state.tags.tag,
    v2tags: state.v2tags,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    createV2TrainingModule: (params) => {
      return dispatch(createV2TrainingModule(params))
    },
    getV2TrainingModules: (options) => {
      dispatch(getV2TrainingModules(options))
    },
    updateV2TrainingModule: (params) => {
      return dispatch(updateV2TrainingModule(params))
    },
    archiveV2TrainingModule: (moduleId) => dispatch(archiveV2TrainingModule(moduleId)),
    unarchiveV2TrainingModule: (moduleId) => dispatch(unarchiveV2TrainingModule(moduleId)),
    renameTag: (options) => {
      return v2TrainingModulesActions.renameTag(options)
    },
    getCategorizedTags: () => {
      return dispatch(getCategorizedTags())
    },
    createTag: (details) => {
      return dispatch(createTag(details))
    },
    updateTag: (options) => {
      return dispatch(updateTag(options))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(V2TrainingModules);



// WEBPACK FOOTER //
// ./src/views/v2_training_modules.js